const PASSWORD_RESET_VERIFIED_KEY = 'betiyan_admin_password_reset_verified';

function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function setPasswordResetVerified(email: string): void {
  sessionStorage.setItem(PASSWORD_RESET_VERIFIED_KEY, normalizeEmail(email));
}

export function isPasswordResetVerified(email: string): boolean {
  const stored = sessionStorage.getItem(PASSWORD_RESET_VERIFIED_KEY);
  return stored === normalizeEmail(email);
}

export function clearPasswordResetVerified(): void {
  sessionStorage.removeItem(PASSWORD_RESET_VERIFIED_KEY);
}
